export const ANALYTICS_PAGE_CLICK = 'paginatePeopleButton';
